export default {"src":"/_next/static/media/dobrozem-sad.1bf8068b.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};